import {
  SET_CLIENT_PROJECT_DATA,
  RESET_CLIENT_PROJECT,
} from "../actions/ClientProject";

const initialState = {
  project_name: "",
  project_initials: "",
  cost_center: undefined,
  client: null,
  ticket_format: [],
  sowActions: [],
  documents: [],
};

const clientProject = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_PROJECT_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CLIENT_PROJECT:
      return initialState;
    default:
      return state;
  }
};

export default clientProject;
